/* eslint-disable */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function isDesktopHoverEnabled(behaviour) {
    return window.matchMedia('(pointer:fine)').matches && behaviour === 'hover';
  }

  function getBehaviour(wrappers) {
    return (wrappers[0] && wrappers[0].getAttribute('data-behavior')) || 'hover';
  }

  function closeAllPanels() {
    document.querySelectorAll('.menu__item-megamenu details[open]').forEach(function (d) {
      d.open = false;
    });
  }

  ready(function () {
    var wrappers = document.querySelectorAll('.mega-menu-wrapper[data-behavior]');
    var behaviour = wrappers.length > 0 ? getBehaviour(wrappers) : 'click';

    // Setup summary accessibility (only for mega menu items if wrappers exist)
    if (wrappers.length > 0) {
      document.querySelectorAll('.menu__item-megamenu details > summary').forEach(function (summary) {
        summary.setAttribute('role', 'button');
        summary.setAttribute('tabindex', '0');
        summary.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            summary.click();
          }
          if (event.key === 'Escape') {
            var parentDetails = summary.parentElement;
            parentDetails.open = false;
            summary.focus();
          }
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
            event.preventDefault();
            var firstLink = summary.parentElement.querySelector('a, button');
            if (firstLink) firstLink.focus();
          }
        });
      });
    }

    // Mobile smooth accordion animation - always runs on mobile devices
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function isMobile() {
      return window.matchMedia('(max-width: 1024px)').matches;
    }

    function getContentElement(details) {
      // Prefer mega menu wrapper; otherwise fallback to regular dropdown list
      return details.querySelector('.mega-menu-wrapper, .menu-dropdown');
    }

    function animateOpen(details, content) {
      if (!content) return;
      if (details.dataset.animating === 'true') return;
      details.dataset.animating = 'true';

      // Synchronously set initial state to avoid flash
      content.style.overflow = 'hidden';
      content.style.display = 'block';
      content.style.height = '0px';
      if (!prefersReduced) {
        content.style.opacity = '0';
        content.style.transition = 'none';
      }

      // First reflow locks the 0px height
      void content.offsetHeight;

      var target = content.scrollHeight;

      // Second frame: enable transition and expand
      requestAnimationFrame(function () {
        if (!prefersReduced) {
          content.style.transition = 'height 260ms ease, opacity 200ms ease';
        }
        content.style.height = target + 'px';
        if (!prefersReduced) content.style.opacity = '1';
      });

      function cleanup() {
        content.style.removeProperty('height');
        content.style.removeProperty('overflow');
        content.style.removeProperty('transition');
        content.style.removeProperty('opacity');
        details.dataset.animating = 'false';
        content.removeEventListener('transitionend', onEnd);
      }

      function onEnd(e) {
        if (e.propertyName === 'height') cleanup();
      }

      if (!prefersReduced) {
        content.addEventListener('transitionend', onEnd);
      } else {
        cleanup();
      }
    }

    function animateClose(details, content) {
      if (!content) return;
      if (details.dataset.animating === 'true') return;
      details.dataset.animating = 'true';

      // Measure current height
      var start = content.scrollHeight;
      content.style.overflow = 'hidden';
      content.style.height = start + 'px';
      content.style.display = 'block';
      if (!prefersReduced) content.style.transition = 'none';

      // Lock starting point
      void content.offsetHeight;

      // Next frame: collapse to 0 with transition
      requestAnimationFrame(function () {
        if (!prefersReduced) {
          content.style.transition = 'height 240ms ease, opacity 200ms ease';
          content.style.opacity = '0';
        }
        content.style.height = '0px';
      });

      function cleanup() {
        content.style.removeProperty('height');
        content.style.removeProperty('overflow');
        content.style.removeProperty('transition');
        // When closed, hide the element so it doesn't capture focus
        content.style.display = '';
        content.style.removeProperty('opacity');
        details.dataset.animating = 'false';
        content.removeEventListener('transitionend', onEnd);
        // After animation completes, reflect closed state on <details>
        details.removeAttribute('open');
      }

      function onEnd(e) {
        if (e.propertyName === 'height') cleanup();
      }

      if (!prefersReduced) {
        content.addEventListener('transitionend', onEnd);
      } else {
        cleanup();
      }
    }

    // Set up mobile smooth accordion for all menu items
    document.querySelectorAll('.menu__item details > summary').forEach(function (summary) {
      summary.addEventListener('click', function (event) {
        var details = summary.parentElement;
        if (!details) return;

        // Only run accordion behavior for mobile; desktop click fallback stays instant
        if (!isMobile()) return;

        // Prevent default behavior immediately to avoid browser's native toggle snap
        event.preventDefault();

        var content = getContentElement(details);
        var isOpen = details.hasAttribute('open');

        // Close all panels except current when opening
        if (!isOpen) {
          document.querySelectorAll('.menu__item details[open]').forEach(function (d) {
            if (d === details) return;
            var c = getContentElement(d);
            d.removeAttribute('open');
            animateClose(d, c);
            var s = d.querySelector('summary');
            if (s) s.setAttribute('aria-expanded', 'false');
          });
        }

        // Toggle current with animation
        if (!isOpen) {
          // Reflect open state, then animate in two frames to avoid snap
          details.setAttribute('open', 'open');
          summary.setAttribute('aria-expanded', 'true');
          animateOpen(details, content);
        } else {
          summary.setAttribute('aria-expanded', 'false');
          animateClose(details, content);
        }
      });
    });

    // Desktop slide animation functions
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function getDesktopContentElement(details) {
      return details.querySelector('.mega-menu-wrapper');
    }

    function animateDesktopOpen(details, content) {
      if (!content) return;
      if (isMobile()) return; // Desktop only
      // Let CSS handle fade-in via details[open] selectors
      details.dataset.desktopAnimating = 'false';
      delete details.dataset.desktopOpenStarted;
    }

    function animateDesktopClose(details, content) {
      if (!content) return;
      if (isMobile()) return; // Desktop only
      // Let CSS handle fade-out when details.open is removed
      details.dataset.desktopAnimating = 'false';
      delete details.dataset.desktopOpenStarted;
      delete details.dataset.desktopHoverLockUntil;
    }

    // Hover intent for desktop (only if wrappers exist and behavior is hover)
    if (wrappers.length > 0 && isDesktopHoverEnabled(behaviour)) {
      var openTimer;
      var closeTimer;

      document.querySelectorAll('.menu__item-megamenu details').forEach(function (details) {
        var summary = details.querySelector('summary');

        function openPanel() {
          clearTimeout(closeTimer);
          openTimer = setTimeout(function () {
            if (!details.hasAttribute('data-manual-close')) {
              var content = getDesktopContentElement(details);
              // Set data-desktop-animating BEFORE opening to disable CSS transitions
              // But only if we're going to animate (desktop + content exists)
              if (!isMobile() && content) {
                // Set a short hover-lock to prevent immediate close during the opening animation start
                details.dataset.desktopHoverLockUntil = String(Date.now() + 450);
                details.dataset.desktopAnimating = 'true';
                details.open = true;
                // Animate slide down on desktop
                animateDesktopOpen(details, content);
              } else {
                details.open = true;
              }
            }
          }, 60);
        }

        function closePanel() {
          clearTimeout(openTimer);
          closeTimer = setTimeout(function () {
            // Respect hover-lock during the beginning of open to avoid double slide/flicker
            var lockUntil = parseInt(details.dataset.desktopHoverLockUntil || '0', 10);
            if (lockUntil && Date.now() < lockUntil) {
              clearTimeout(closeTimer);
              closeTimer = setTimeout(closePanel, 60);
              return;
            }
            var content = getDesktopContentElement(details);
            // Desktop: rely on CSS fade-out by removing 'open' immediately
            details.removeAttribute('data-manual-close');
            details.open = false;
            if (summary) summary.setAttribute('aria-expanded', 'false');
          }, 120);
        }

        details.addEventListener('mouseenter', function () {
          openPanel();
          if (summary) summary.setAttribute('aria-expanded', 'true');
        });

        details.addEventListener('mouseleave', closePanel);

        // Keep panel open when focusing inside
        details.addEventListener('focusin', function () {
          clearTimeout(closeTimer);
          var content = getDesktopContentElement(details);
          // Set data-desktop-animating BEFORE opening to disable CSS transitions
          if (!isMobile() && content) {
            details.open = true;
            // Let CSS handle fade-in
          } else {
            details.open = true;
          }
          if (summary) summary.setAttribute('aria-expanded', 'true');
        });

        details.addEventListener('focusout', function (event) {
          var related = event.relatedTarget;
          if (!related || !details.contains(related)) {
            closePanel();
          }
        });

        // Allow manual toggle on summary click without fighting hover
        // Note: On mobile, the smooth animation handler above will take precedence
        if (summary) {
          summary.addEventListener('click', function (event) {
            // Skip if mobile (mobile handler will take care of it)
            if (isMobile()) return;
            
            if (summary.getAttribute('aria-expanded') === 'true') {
              details.setAttribute('data-manual-close', 'true');
              var content = getDesktopContentElement(details);
              // Animate slide up on desktop before closing
              if (!isMobile() && content) {
                animateDesktopClose(details, content);
                setTimeout(function () {
                  details.open = false;
                  summary.setAttribute('aria-expanded', 'false');
                }, 400);
              } else {
                details.open = false;
                summary.setAttribute('aria-expanded', 'false');
              }
              event.preventDefault();
            } else {
              closeAllPanels();
              var content = getDesktopContentElement(details);
              // Set data-desktop-animating BEFORE opening to disable CSS transitions
              if (!isMobile() && content) {
                details.open = true;
                // Let CSS handle fade-in
              } else {
                details.open = true;
              }
              summary.setAttribute('aria-expanded', 'true');
            }
          });
        }
      });
    }

    // Close on ESC anywhere
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAllPanels();
      }
    });

    // Close on outside click
    document.addEventListener('click', function (event) {
      var isMenuClick = event.target.closest('.menu__item-megamenu');
      if (!isMenuClick) {
        closeAllPanels();
      }
    });

    // Replace &nbsp; entities with regular spaces in promo text elements
    function replaceNonBreakingSpaces() {
      var promoElements = document.querySelectorAll('.mega-menu__promo-heading, .mega-menu__promo-tagline, .mega-menu__promo-link, .mega-menu__badge');
      promoElements.forEach(function (element) {
        if (element.innerHTML.indexOf('&nbsp;') !== -1) {
          element.innerHTML = element.innerHTML.replace(/&nbsp;/g, ' ');
        }
        // Also handle text nodes that might contain non-breaking spaces
        var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false);
        var node;
        while (node = walker.nextNode()) {
          if (node.nodeValue.indexOf('\u00A0') !== -1) {
            node.nodeValue = node.nodeValue.replace(/\u00A0/g, ' ');
          }
        }
      });
    }

    replaceNonBreakingSpaces();
    // Also run after a short delay to catch dynamically loaded content
    setTimeout(replaceNonBreakingSpaces, 100);

    // Fade-in and float-up animations for mega menu blocks
    function initMegaMenuAnimations() {
      var animatedMenus = new Set();
      
      function animateMegaMenu(wrapper) {
        if (!wrapper || animatedMenus.has(wrapper)) return;
        
        // Skip animations on desktop - content should slide down with container
        if (!isMobile()) {
          // On desktop, ensure content is immediately visible (no fade-in)
          var menu = wrapper.querySelector('.mega-menu');
          if (menu) {
            var allElements = menu.querySelectorAll('.mega-menu__column, .mega-menu__promo, .mega-menu__intro');
            allElements.forEach(function (el) {
              el.style.opacity = '1';
              el.style.transform = 'none';
            });
          }
          animatedMenus.add(wrapper);
          return;
        }
        
        var menu = wrapper.querySelector('.mega-menu');
        if (!menu) return;
        
        // Get all elements to animate
        var columns = Array.from(menu.querySelectorAll('.mega-menu__column'));
        var promos = Array.from(menu.querySelectorAll('.mega-menu__promo'));
        var intro = menu.querySelector('.mega-menu__intro');
        
        var allElements = [];
        if (intro) allElements.push(intro);
        allElements = allElements.concat(columns);
        allElements = allElements.concat(promos);
        
        if (allElements.length === 0) return;
        
        // Add initial animation class
        allElements.forEach(function (el) {
          el.classList.add('mega-menu-animate');
        });
        
        // Force reflow
        void wrapper.offsetHeight;
        
        // Trigger animations with staggered delays
        requestAnimationFrame(function () {
          allElements.forEach(function (el, index) {
            var delay = index * 50; // 50ms stagger between elements
            setTimeout(function () {
              el.classList.add('mega-menu-animate--active');
              
              // Clean up after animation completes
              setTimeout(function () {
                el.classList.remove('mega-menu-animate', 'mega-menu-animate--active');
                el.style.willChange = '';
              }, 700);
            }, delay);
          });
        });
        
        animatedMenus.add(wrapper);
      }
      
      // Watch for mega menu opening
      function handleMenuOpen(event) {
        var target = event.target;
        if (target.nodeName === 'DETAILS' && target.hasAttribute('open')) {
          var wrapper = target.querySelector('.mega-menu-wrapper');
          if (wrapper) {
            // Small delay to ensure menu is visible
            setTimeout(function () {
              animateMegaMenu(wrapper);
            }, 50);
          }
        }
      }
      
      // Watch for details element changes
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            var target = mutation.target;
            if (target.nodeName === 'DETAILS' && target.hasAttribute('open')) {
              var wrapper = target.querySelector('.mega-menu-wrapper');
              if (wrapper && !animatedMenus.has(wrapper)) {
                setTimeout(function () {
                  animateMegaMenu(wrapper);
                }, 50);
              }
            } else {
              // Reset animation when menu closes
              var closedWrapper = target.querySelector('.mega-menu-wrapper');
              if (closedWrapper) {
                animatedMenus.delete(closedWrapper);
                var elements = closedWrapper.querySelectorAll('.mega-menu-animate, .mega-menu-animate--active');
                elements.forEach(function (el) {
                  el.classList.remove('mega-menu-animate', 'mega-menu-animate--active');
                  el.style.willChange = '';
                });
              }
            }
          }
        });
      });
      
      // Observe all details elements in mega menu
      document.querySelectorAll('.menu__item-megamenu details').forEach(function (details) {
        observer.observe(details, {
          attributes: true,
          attributeFilter: ['open']
        });
      });
      
      // Also use Intersection Observer for mobile menu visibility
      var menuWrappers = document.querySelectorAll('.mega-menu-wrapper');
      if (menuWrappers.length > 0 && 'IntersectionObserver' in window) {
        var intersectionObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio > 0.1) {
              var wrapper = entry.target;
              if (!animatedMenus.has(wrapper)) {
                setTimeout(function () {
                  animateMegaMenu(wrapper);
                }, 50);
              }
            }
          });
        }, {
          threshold: 0.1
        });
        
        menuWrappers.forEach(function (wrapper) {
          intersectionObserver.observe(wrapper);
        });
      }
    }
    
    initMegaMenuAnimations();

    // Fix promo overlay link - allow individual links to be clickable
    function fixPromoOverlayLinks() {
      document.querySelectorAll('.mega-menu__promo').forEach(function (promo) {
        var overlayLink = promo.querySelector('.mega-menu__promo-overlay-link');
        if (!overlayLink) return;
        
        var overlayUrl = overlayLink.getAttribute('href');
        if (!overlayUrl) return;
        
        // Handle clicks on promo that aren't on links
        promo.addEventListener('click', function (event) {
          // Check if click target is a link or inside a link
          var clickedLink = event.target.closest('a');
          if (clickedLink) {
            // Let the link handle its own click
            return;
          }
          
          // If clicking on non-link areas, navigate to overlay link
          event.preventDefault();
          window.location.href = overlayUrl;
        });
      });
    }
    
    fixPromoOverlayLinks();
    // Also run after a delay to catch dynamically loaded content
    setTimeout(fixPromoOverlayLinks, 100);

    // Video hover playback for promo images
    function initPromoVideoHover() {
      var promoContainers = document.querySelectorAll('.mega-menu__promo');
      
      promoContainers.forEach(function (promo) {
        var mediaContainer = promo.querySelector('.mega-menu__promo-media');
        var video = promo.querySelector('.mega-menu__promo-video');
        var image = promo.querySelector('.mega-menu__promo-image');
        
        // If no video element exists, ensure has-video class is not present and image stays visible
        if (!video) {
          if (mediaContainer) {
            mediaContainer.classList.remove('has-video');
          }
          promo.classList.remove('has-video');
          if (image) {
            image.style.opacity = '1';
            // Ensure inline style doesn't get overridden
            image.setAttribute('data-no-video', 'true');
          }
          return;
        }
        
        if (!mediaContainer) return;
        
        // Check if video source is valid (not placeholder)
        var videoSource = video.querySelector('source');
        var videoSrc = videoSource ? (videoSource.src || videoSource.getAttribute('src')) : null;
        if (!videoSource || !videoSrc || videoSrc === 'VideoDrop' || videoSrc.trim() === '' || videoSrc.indexOf('VideoDrop') !== -1) {
          // Invalid video source - remove video and keep image visible
          video.remove();
          mediaContainer.classList.remove('has-video');
          promo.classList.remove('has-video');
          // Ensure image is visible
          if (image) {
            image.style.opacity = '1';
            image.setAttribute('data-no-video', 'true');
          }
          return;
        }
        
        // Add class to indicate video exists for CSS targeting
        mediaContainer.classList.add('has-video');
        promo.classList.add('has-video');
        
        // Check if mobile device
        var isMobile = window.matchMedia('(max-width: 1024px)').matches;
        
        // Remove any existing event listeners by cloning and replacing
        if (promo.hasAttribute('data-video-initialized')) {
          return; // Already initialized
        }
        promo.setAttribute('data-video-initialized', 'true');
        
        if (isMobile) {
          // Mobile: autoplay and loop video
          video.setAttribute('autoplay', '');
          video.style.opacity = '1';
          var image = promo.querySelector('.mega-menu__promo-image');
          if (image) {
            image.style.opacity = '0';
          }
          video.play().catch(function (error) {
            console.log('Video autoplay failed:', error);
          });
        } else {
          // Desktop: hover to play
          var isHovering = false;
          
          function playVideo() {
            if (isHovering) return;
            isHovering = true;
            video.play().catch(function (error) {
              // Handle autoplay restrictions
              console.log('Video play failed:', error);
            });
          }
          
          function pauseVideo() {
            if (!isHovering) return;
            isHovering = false;
            video.pause();
            video.currentTime = 0; // Reset to start
          }
          
          // Listen for hover on entire promo container
          promo.addEventListener('mouseenter', playVideo);
          promo.addEventListener('mouseleave', pauseVideo);
        }
      });
    }
    
    initPromoVideoHover();
    // Also run after a delay to catch dynamically loaded content
    setTimeout(initPromoVideoHover, 100);
    
    // Reinitialize on resize to handle mobile/desktop switching
    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        // Remove initialization flags to allow reinitialization
        document.querySelectorAll('.mega-menu__promo[data-video-initialized]').forEach(function (promo) {
          promo.removeAttribute('data-video-initialized');
        });
        initPromoVideoHover();
      }, 250);
    });

    // Full-width horizontal dropdown layer for standard (non-mega) menus
    function initHorizontalDropdownLayer() {
      var desktopQuery = window.matchMedia('(min-width: 1025px)');

      function setupForHeader(headerEl) {
        var layer = headerEl.querySelector('.menu-horizontal-layer');
        if (!layer) return;

        var hideTimer;

        function showFrom(detailsEl) {
          if (!desktopQuery.matches) return;
          clearTimeout(hideTimer);
          var ul = detailsEl.querySelector('ul.menu-dropdown');
          if (!ul) return;
          // Clone to avoid moving original node and keep aria/roles
          var clone = ul.cloneNode(true);
          clone.classList.add('menu-dropdown--horizontal');
          // Inject
          layer.innerHTML = '';
          layer.appendChild(clone);
          layer.setAttribute('aria-hidden', 'false');
          layer.classList.add('is-visible');
        }

        function hideLayerDelayed() {
          hideTimer = setTimeout(function () {
            layer.classList.remove('is-visible');
            layer.setAttribute('aria-hidden', 'true');
            layer.innerHTML = '';
          }, 120);
        }

        // Bind events on non-mega top-level items that have standard submenus
        headerEl.querySelectorAll('.main__menu > li.menu__item:not(.menu__item-megamenu) > sht-menu-header > details').forEach(function (details) {
          var summary = details.querySelector('summary');
          details.addEventListener('mouseenter', function () { showFrom(details); });
          details.addEventListener('focusin', function () { showFrom(details); });
          if (summary) {
            summary.addEventListener('keydown', function (e) {
              if (!desktopQuery.matches) return;
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                showFrom(details);
              }
            });
          }
        });

        // Keep visible while hovering the layer; hide when leaving header
        headerEl.addEventListener('mouseleave', hideLayerDelayed);
        layer.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
        layer.addEventListener('mouseleave', hideLayerDelayed);

        // Collapse on breakpoint change
        function handleBreakpoint() {
          if (!desktopQuery.matches) {
            layer.classList.remove('is-visible');
            layer.setAttribute('aria-hidden', 'true');
            layer.innerHTML = '';
          }
        }
        if (desktopQuery.addEventListener) {
          desktopQuery.addEventListener('change', handleBreakpoint);
        } else if (desktopQuery.addListener) {
          desktopQuery.addListener(handleBreakpoint);
        }
      }

      document.querySelectorAll('sht-header .header').forEach(setupForHeader);
    }

    initHorizontalDropdownLayer();

    // (removed glare hover initializer)

  });
})();

